import React from 'react';
import FaqSection from 'components/FaqSection';
import GuideSection from 'components/GuideSection';
import Link from 'next/link';
import SideBar from './SideBar';
import { HeaderH2, HeaderH1, Text, NextButton } from 'components/TextBlocks';
import Clients from 'components/Clients';
import Image from 'next/image';
import { motion } from 'framer-motion';

export const OpenIcon = () => {
    return (
        <svg
            height="20"
            width="20"
            fill="none"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg"
            style={{ marginLeft: '8px' }}
        >
            <path
                d="M11 3C10.4477 3 10 3.44772 10 4C10 4.55228 10.4477 5 11 5H13.5858L7.29289 11.2929C6.90237 11.6834 6.90237 12.3166 7.29289 12.7071C7.68342 13.0976 8.31658 13.0976 8.70711 12.7071L15 6.41421V9C15 9.55228 15.4477 10 16 10C16.5523 10 17 9.55228 17 9V4C17 3.44772 16.5523 3 16 3H11Z"
                fill={'#0C92A0'}
            />
            <path
                d="M5 5C3.89543 5 3 5.89543 3 7V15C3 16.1046 3.89543 17 5 17H13C14.1046 17 15 16.1046 15 15V12C15 11.4477 14.5523 11 14 11C13.4477 11 13 11.4477 13 12V15H5V7L8 7C8.55228 7 9 6.55228 9 6C9 5.44772 8.55228 5 8 5H5Z"
                fill={'#0C92A0'}
            />
        </svg>
    );
};

const Webstore = ({ image, alt, text, url, unaval }) => {
    return (
        <motion.div
            whileHover={{ y: -1 }}
            style={{ maxWidth: '330px', pointerEvents: unaval ? 'none' : '' }}
        >
            <Link href={url} target="_blank">
                <div
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        marginTop: '36px',
                        marginBottom: '36px',
                        opacity: unaval ? '0.6' : '1'
                    }}
                >
                    <Image
                        src={image}
                        width={35}
                        height={35}
                        alt={text}
                    ></Image>
                    <p
                        style={{
                            color: '#04184a',
                            marginLeft: '12px',
                            fontSize: '1.125rem',
                            fontWeight: '500'
                        }}
                    >
                        {text}
                    </p>
                    {!unaval && <OpenIcon />}
                </div>
            </Link>
        </motion.div>
    );
};

function GettingStarted(props) {
    return (
        <>
            <HeaderH1>Getting started</HeaderH1>
            <Text>
                Welcome to the tabExtend guide, if you have any questions or
                suggestions please contact us at{' '}
                <a href="mailto:info@tabextend.com">info@tabextend.com</a>
            </Text>
            <HeaderH2 id="Installation">Installation</HeaderH2>
            <Text>
                To install the tabExtend extension visit the web store for your
                browser using one of the links below. Simply add to browser and
                open a new tab in your browser to begin using tabExtend. All
                features will be available without the need to login or create
                an account.{' '}
                <Link href="/guide/create-account">Create an account</Link> to
                secure and access your data from anywhere.
            </Text>
            <Webstore
                image={'/browsers/Chrome_logo.png'}
                alt={'Chromestore'}
                text={'Chrome Web Store'}
                url={
                    'https://chrome.google.com/webstore/detail/tabextend/ffikidnnejmibopbgbelephlpigeniph'
                }
                unaval={false}
            />
            <Webstore
                image={'/browsers/Brave_logo.png'}
                alt={'Brave extensions'}
                text={'Brave extensions'}
                url={
                    'https://chrome.google.com/webstore/detail/tabextend/ffikidnnejmibopbgbelephlpigeniph'
                }
                unaval={false}
            />
            <Webstore
                image={'/browsers/Edge_logo.png'}
                alt={'Edgestore'}
                text={'Edge Add-ons'}
                url={
                    'https://microsoftedge.microsoft.com/addons/detail/tabextend/afddlgcjhdhkgimldgmppegmnbmogolg'
                }
                unaval={false}
            />
            {/*       <Webstore
        image={"/browsers/Opera_logo.png"}
        alt={"Opera"}
        text={"Opera Add-ons (Coming soon)"}
        unaval={true}
        url={"https://www.tabextend.com"}
      />
      <Webstore
        image={"/browsers/Safari_logo.png"}
        alt={"Appstore"}
        text={"App Store (Coming soon)"}
        unaval={true}
        url={"https://www.tabextend.com"}
      /> */}
            <HeaderH2 id="Permissions">Permissions</HeaderH2>
            <Text>
                To run the extension it needs some permissions from the user,
                read about each one here and why they are needed.
            </Text>
            <p
                style={{
                    fontFamily: 'Rubik, sans-serif',
                    color: '#646F7D',
                    fontSize: '1.175rem',
                    fontWeight: '400',
                    lineHeight: '2rem',
                    paddingLeft: '12px'
                }}
            >
                <span style={{ fontWeight: '500', marginLeft: '-12px' }}>
                    • Replace the page that you see when opening a new tab{' '}
                </span>{' '}
                - Used for replacing your default new tab with the tabExtend
                overview.
            </p>
            <p
                style={{
                    fontFamily: 'Rubik, sans-serif',
                    color: '#646F7D',
                    fontSize: '1.175rem',
                    fontWeight: '400',
                    lineHeight: '2rem',
                    paddingLeft: '12px',
                    marginTop: '24px'
                }}
            >
                <span style={{ fontWeight: '500', marginLeft: '-12px' }}>
                    • Read your browsing history{' '}
                </span>{' '}
                - Used for showing active tabs in the current window and to save
                them into groups.
            </p>
            <p
                style={{
                    fontFamily: 'Rubik, sans-serif',
                    color: '#646F7D',
                    fontSize: '1.175rem',
                    fontWeight: '400',
                    lineHeight: '2rem',
                    paddingLeft: '12px',
                    marginTop: '24px'
                }}
            >
                <span style={{ fontWeight: '500', marginLeft: '-12px' }}>
                    • Manage your downloads (Optional){' '}
                </span>{' '}
                - Used when and if you want to export your data locally as a
                JSON file. After export, the file will be located in your
                download folder.
            </p>
            <p
                style={{
                    fontFamily: 'Rubik, sans-serif',
                    color: '#646F7D',
                    fontSize: '1.175rem',
                    fontWeight: '400',
                    lineHeight: '2rem',
                    paddingLeft: '12px',
                    marginTop: '24px'
                }}
            >
                <span style={{ fontWeight: '500', marginLeft: '-12px' }}>
                    • Most visited URL (Optional)
                </span>{' '}
                - Used to create a group with your most visited sites. This is
                an optional permission only asked if you want to create a "Most
                visited" group.
            </p>
            <p
                style={{
                    fontFamily: 'Rubik, sans-serif',
                    color: '#646F7D',
                    fontSize: '1.175rem',
                    fontWeight: '400',
                    lineHeight: '2rem',
                    paddingLeft: '12px',
                    marginTop: '24px'
                }}
            >
                <span style={{ fontWeight: '500', marginLeft: '-12px' }}>
                    • Bookmarks (Optional)
                </span>{' '}
                - Used to create groups out of selected Bookmarks folder. This
                is an optional permission only asked if you want to import
                bookmarks of your choice.
            </p>
            <NextButton
                cta={'Overview'}
                textColor={'#565D65'}
                bg={'#EBECED'}
                page={'/guide/overview'}
            />
        </>
    );
}

GettingStarted.Layout = SideBar;

export default GettingStarted;
